import { apiUc } from 'http/index';

export const getAgentStatus = async (agent) => {
  const {
    data: { data }
  } = await await apiUc.get(`/api/agent-status/${agent}`);

  return data;
};
